import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import AboutUs from '../components/AboutUs';
import Stories from '../components/Stories';
import DonutFlavors from '../components/DonutFlavors';
import HowToOrder from '../components/HowToOrder';
import OrderForm from '../components/OrderForm';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import SprinkleBackground from '../components/SprinkleBackground';

gsap.registerPlugin(ScrollTrigger);

const Home = () => {
  return (
    <div className="relative min-h-screen">
      <SprinkleBackground />
      <Navigation />
      <Hero />
      <AboutUs />
      <Stories />
      <DonutFlavors />
      <HowToOrder />
      <OrderForm />
      <FAQ />
      <Footer />
    </div>
  );
};

export default Home;